/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import useUser from '../../../../Shared/UserProvider/useUser'
import { getCheckoutSystem } from '../../../../../services/PointOfSale/PointOfSale.service'
import { useTranslation } from 'react-i18next'
import { Icon, IconGroup } from 'semantic-ui-react'
import { format, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'
import { NoCheckoutSystemCardContent } from './NoCheckoutSystemCardContent'
import { TIME } from '../../../../../services/date.service'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'


const CheckoutSystemCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['checkout-system', user.provider.object.id],
        queryFn: () => getCheckoutSystem(user.provider.object.id),
        staleTime: TIME.MINUTE_IN_MS * 5,
    })

    const getBorderColor = () => {
        if (isLoading || !data || data.state === undefined) {
            return 'unset'
        }

        return data.state.status === 'OK' ? '#22c55e' : '#dc2626'
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};

            .card-content {
                width: 283px;
                height: 80px;
            }
        `}
      >
          <CardContent
            className="card-content"
            css={css`
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                padding: ${isLoading ? '0' : '1rem'};
            `}
          >
              {isLoading ? (
                <LoadingPlaceholderCardContent/>
              ) : !data ? <NoCheckoutSystemCardContent/> : (
                (
                  <div
                    css={css`
                        width: 100%;
                    `}
                  >
                      <div
                        css={css`
                            display: flex;
                            align-items: center;
                            column-gap: .5rem;
                            margin-bottom: .5rem;
                        `}
                      >
                          <IconGroup size="big">
                              <Icon color="grey" name="plug"/>
                              <Icon
                                corner
                                name={(data.state === undefined || data.state.status === 'OK') ? 'checkmark' : 'ban'}
                                color={(data.state === undefined || data.state.status === 'OK') ? 'green' : 'red'}
                              />
                          </IconGroup>
                          <p
                            css={css`
                                margin-right: .5rem;
                                font-weight: bold;
                            `}>
                              {t('checkout_system.checkout_system', {moduleName: t(`checkout_system.module_name.${data?.module}`)})}
                          </p>
                      </div>
                      {data.state?.sentAt &&
                        <p>
                            {t('checkout_system.state.lastSentAt', {date: format(parseISO(data.state.sentAt), 'dd/MM/YYY kk:mm:ss', {locale: fr})})}
                        </p>
                      }
                  </div>
                )
              )}
          </CardContent>
      </Card>
    )
}

export { CheckoutSystemCard }
